import * as React from "react";
import { PulseSquare24Filled, PulseSquare24Regular } from "@fluentui/react-icons";

import { TeamAppConfig } from "Apps/TeamAppModel";

const CanaryHealthApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "CanaryHealth" */ "./CanaryHealth");
    return { default: namedExport.CanaryHealth };
});

export const CanaryHealth: TeamAppConfig = {
    title: "Canary Health",
    regularIcon: PulseSquare24Regular,
    filledIcon: PulseSquare24Filled,
    description:
        "Real-time resource health across the M365 fleet — entity health verdicts, blast radius, and signal " +
        "provenance from Resource Health Monitoring (RHM).",
    team: "Foundation",
    publicId: "FoundationResilience",
    owner: "joshuacruz@microsoft.com",
    role: "*",
    tags: ["health", "resilience", "rhm", "fleet", "availability", "topology", "canary"],
    app: CanaryHealthApp,
    path: "/Foundation/CanaryHealth"
};
